import { render, staticRenderFns } from "./MyBrandRoom.vue?vue&type=template&id=13e2b74a"
import script from "./MyBrandRoom.vue?vue&type=script&lang=js"
export * from "./MyBrandRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports